import { Grid, Typography } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

// relative imports
import LedgibleButton from '../../shared/custom-components/buttons/LedgibleButton';
import useAlternativeDisplay from '../../shared/custom-hooks/useAlternativeDisplay';
import Header from '../../shared/header/Header';
import NotFoundImage from '../../shared/img-assets/pages/404-ledgible.png';
import { getContextualAppPath } from '../../shared/utilities/appUtilities';

const useStyles = makeStyles()((theme, { headerHeight, hideHeader }) => ({
  mainContent: {
    position: 'fixed',
    top: hideHeader ? 0 : headerHeight || 56,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    paddingTop: theme.spacing(10),
    overflowY: 'auto',
    backgroundColor: theme.palette.common.white,
  },
}));

const NotFoundPage = () => {
  const { pathname } = useLocation();
  const { isMobile } = useAlternativeDisplay();
  const [headerHeight, setHeaderHeight] = useState(() => {
    if (isMobile) return 57;
    return 56;
  });
  const { classes } = useStyles({ headerHeight });

  return (
    <>
      <Header
        hideAccountMenu
        hideSecondaryMenu
        hideUpdateButton
        setHeaderHeight={setHeaderHeight}
      />
      <div className={classes.mainContent}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs="auto"
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
          >
            <Grid item mt={8}>
              <img src={NotFoundImage} alt="Asset not found" height={180} />
            </Grid>
            <Grid item mt={3}>
              <Typography variant="h5" color="secondary" align="center">
                <strong>Page Not Found</strong>
              </Typography>
              <Typography variant="body1" align="center">
                Looks like you took a wrong turn
              </Typography>
              <Typography variant="body1" align="center">
                (or we moved something)
              </Typography>
            </Grid>
            <Grid item mt={3}>
              <LedgibleButton
                component={Link}
                textTransformOff
                variant="contained"
                color="primary"
                to={(getContextualAppPath('/') || '/').replace(/\/$/, '') || '/'}
                id={`not-found-for-${pathname}`}
              >
                Get me out of here!
              </LedgibleButton>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default NotFoundPage;
